import { render, staticRenderFns } from "./babyDialog.vue?vue&type=template&id=5fdcb350&scoped=true&"
import script from "./babyDialog.vue?vue&type=script&lang=js&"
export * from "./babyDialog.vue?vue&type=script&lang=js&"
import style0 from "./babyDialog.vue?vue&type=style&index=0&id=5fdcb350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdcb350",
  null
  
)

export default component.exports